import 'url-polyfill';

export function getParam(param) {
  return new URL(window.location.href).searchParams.get(param);
}

export function getDomain() {
  const referer = new URL(window.location.href).searchParams.get('domain') || 'http://www.bestfotokonyv.hu';
  return referer;
}



// WEBPACK FOOTER //
// ./src/redux/helpers/getParams.js